<template>
  <div style="display: inline-block;">
    <div class="as-wrapper">
      <div class="as-item">
        <div class="label"><div class="icon gg-chevron-double-left" style="--ggs: .9;" /></div>
        <div class="value">{{ aggregatedAvailability(dentist).segment.last }}</div>
      </div>

      <div class="as-item">
        <div class="label"><div class="icon gg-shape-square" style="--ggs: .75;" /></div>
        <div class="value">{{ aggregatedAvailability(dentist).segment.current }}</div>
      </div>

      <div class="as-item">
        <div class="label"><div class="icon gg-chevron-double-right" style="--ggs: .9;" /></div>
        <div class="value">{{ aggregatedAvailability(dentist).segment.next }}</div>
      </div>
    </div>

    <div class="as-drop" uk-drop="pos: bottom-center; delay-hide: 0; animation: uk-animation-slide-bottom-small; offset: 0;">
      <div class="as-wrapper">
        <template v-for="(item, index) in aggregatedAvailability(dentist).complete">
          <div :key="index" class="as-item" :class="{ 'today': (index === 7) }" :uk-tooltip="`title: ${item.date}; pos: bottom;`">
            <div class="label">{{ item.label }}</div>
            <div class="value" :class="boxClass(item.value)">{{ item.value }}</div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ComponentAggregatedAvailability',

  props: {
    dentist: {
      type: String,
      required: true
    }
  },

  methods: {
    aggregatedAvailability(dentist) {
      // Get range of last 7 days in the past and the future from today (current date) with moment and moment-range (Total: 15 Days)
      const range = this.$moment().range(this.$moment().subtract(7, 'day'), this.$moment().add(7, 'day'))
      // Convert range to Array and format Array data to match data structure
      const rangeArray = Array.from(range.by('day')).map((m) => m.format('YYMMDD'))
      // Prepare empty Array
      let data = []
      // Load Availability Data
      const { availability } = this.$store.getters['dentists/find'](dentist)

      rangeArray.forEach((date) => {
        // Find value for date or substitute with 0
        const s = availability[date] || {}
        const value = Object.values(s).filter((i) => i === 2).length
        // Push the value into prepared array
        data.push({
          value,
          label: this.$moment(date, 'YYMMDD').format('DD'),
          date: this.$moment(date, 'YYMMDD').format('DD/MM/YYYY')
        })
      })

      const response = {}
      response.complete = data

      data = data.map((a) => a.value)
      response.segment = {
        last: data.slice(0, 7).reduce((a, b) => a + b, 0),
        current: data[7],
        next: data.slice(8, 16).reduce((a, b) => a + b, 0)
      }

      return response
    },

    boxClass(v) {
      let response = 'zero'

      if (v > 0) {
        response = 'low'
      }

      if (v > 2) {
        response = 'medium'
      }

      if (v > 4) {
        response = 'high'
      }

      return response
    }
  }
}
</script>

<style lang="scss">
.as-drop {
  width: 464px;
  background-color: $colour-light;
  box-shadow: 0 14px 25px rgba(0,0,0,.5);
}

.as-wrapper {
  display: flex;
  justify-content: center;

  // .as-divider {
  //   width: 2px;
  //   margin: 2px;
  //   background-color: $colour-secondary;
  // }

  .as-item {
    width: 36px;
    height: 72px;
    background-color: $colour-secondary-light;
    color: $colour-light;
    cursor: help;

    &:not(:last-of-type) {
      margin-right: 1px;
    }

    &.today .label {
      background-color: $colour-primary;
    }

    .label,
    .value {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 36px;
      height: 36px;
    }

    .label {
      background-color: $colour-secondary;
    }

    .value {
      &.zero {
        background-color: $colour-secondary-light;
      }

      &.low {
        background-color: $colour-danger;
      }

      &.medium {
        background-color: $colour-warning;
        color: $colour-secondary;
      }

      &.high {
        background-color: $colour-success;
      }
    }
  }
}
</style>
